export const getCurrencySymbol = (str) => { //返回货币
	if (null == str || str.length <= 0) return "¥";
	let symbol;
	str = str.toUpperCase(); //将小写字母准换为大写字母
	if (str === "EUR") symbol = "€";
	else if (str === "JPY") symbol = "￥";
	else if (str === "TWD") symbol = "NT$";
	else if (str === "KRW") symbol = "₩";
	else if (str === "RUB") symbol = "₽";
	else if (str === "CAD") symbol = "C$";
	else if (str === "GBP") symbol = "£";
	else if (str === "HKD") symbol = "HK$";
	else if (str === "BRL") symbol = "R$";
	else if (str === "AUD") symbol = "A$";
	else if (str === "MXN") symbol = "Mex$";
	else if (str === "PLN") symbol = "zł";
	else if (str === "CHF") symbol = "CHF";
	else if (str === "SEK") symbol = "kr";
	else if (str === "CZK") symbol = "Kč";
	else if (str === "NZD") symbol = "NZ$";
	else if (str === "COP") symbol = "COL$";
	else if (str === "SGD") symbol = "S$";
	else if (str === "MYR") symbol = "RM";
	else if (str === "ILS") symbol = "₪";
	else if (str === "PHP") symbol = "₱";
	else if (str === "DKK") symbol = "kr.";
	else if (str === "NOK") symbol = "kr";
	else if (str === "RON") symbol = "lei";
	else if (str === "INR") symbol = "₹";
	else if (str === "ARS") symbol = "$";
	else if (str === "BGN") symbol = "лв";
	else if (str === "TRY") symbol = "₺";
	else if (str === "ZAR") symbol = "R";
	else if (str === "ISK") symbol = "kr";
	else if (str === "KZT") symbol = "₸";
	else if (str === "HRK") symbol = "kn";
	else if (str === "RSD") symbol = "дин.";
	else if (str === "EGP") symbol = "E£";
	else if (str === "LBP") symbol = "ل.ل";
	else if (str === "VND") symbol = "₫";
	else if (str === "AED") symbol = "د.إ";
	else if (str === "SAR") symbol = "ر.س";
	else if (str === "NGN") symbol = "₦";
	else if (str === "CNY") symbol = "￥";
	else symbol = "$";
	return symbol;
};


export const getAttributeConversion = (str) => { //返回属性
	let attribute;
	switch (str) {
		case "1": //Sado
			attribute = "SADO";
			break;
		case "2": //Mado
			attribute = "MASO";
			break;
		case "3": //Dom
			attribute = "DOM";
			break;
		case "4": //Sub
			attribute = "SUB";
			break;
		case "5": //Sw
			attribute = "SWITCH";
			break;
	}
	return attribute;
};

export const getSexOrientations = (str) => { //返回性取向
	let attribute;
	switch (str) {
		case "1": //BIS
			attribute = "BIS";
			break;
		case "2": //HETERO
			attribute = "HETERO";
			break;
		case "3": //GAY
			attribute = "GAY";
			break;
		case "4": //LES
			attribute = "LES";
			break;
	}
	return attribute;
};



export const getError = (code, language) => { // 返回错误码
    language = language === 'zh-CN' ? 'zh' : 'en'; // 这里直接使用传入的 language
    const messages = {
        en: {
            '600000': 'Default exception type for parameter validation.',
            '600001': 'Mobile number cannot be empty.',
            '600002': 'Request type for verification code cannot be empty.',
            '600003': 'Graphic verification code cannot be empty.',
            '600004': 'Graphic verification code UUID cannot be empty.',
            '600005': 'Country code cannot be empty.',
            '600006': 'Country code length is incorrect, it should be between 1 and 999.',
            '600007': 'Email address cannot be empty.',
            '600008': 'Invalid email format.',
            '600009': 'Registration type cannot be empty.',
            '600010': 'Nickname cannot be empty.',
            '600011': 'Avatar cannot be empty.',
            '600012': 'Password cannot be empty.',
            '600013': 'Password length is incorrect, it should be between 8 and 30 characters.',
            '600014': 'Password format is incorrect, it should contain uppercase letters, lowercase letters, and numbers, and be 8-16 characters long.',
            '600015': 'Verification code cannot be empty.',
            '600016': 'Login type cannot be empty.',
            '600017': 'Device Bluetooth address cannot be empty.',
            '600018': 'Device environment cannot be empty.',
            '600019': 'Device code cannot be empty.',
            '600021': 'Device type cannot be empty.',
            '600022': 'Platform ClientId cannot be empty.',
            '600023': 'Authorization method cannot be empty.',
            '500000': 'Operation failed, please contact the administrator (default unknown exception).',
            '500001': 'Mobile number cannot be empty.',
            '500002': 'Graphic verification code is incorrect.',
            '500003': 'Mobile number does not exist.',
            '500004': 'Mobile number already exists.',
            '500005': 'Request verification code interval is 60 seconds.',
            '500006': 'Exceeded the maximum number of verification codes sent per day, the maximum is 10 times.',
            '500007': 'Verification code sending failed.',
            '500008': 'Email verification code sending failed.',
            '500009': 'Email does not exist.',
            '500010': 'Email already exists.',
            '500011': 'Request body is empty.',
            '500012': 'Verification code is incorrect.',
            '500013': 'Email address cannot be empty.',
            '500014': 'User does not exist.',
            '500015': 'Password cannot be empty.',
            '500016': 'Platform login failed, please contact the administrator.',
            '500017': 'Username or password is incorrect.',
            '500018': 'Platform key is empty, please contact the administrator.',
            '500019': 'Missing environment type parameter in the request header.',
            '500020': 'Environment type parameter is invalid.',
            '500021': 'Data decryption failed.',
            '500022': 'Device does not exist.',
            '500023': 'The device already exists on the current platform.',
            '500024': 'Error adding device to the current platform, please contact the administrator.',
            '500025': 'Device is bound to another platform.',
            '500026': 'Device does not belong to the platform.',
            '500027': 'Failed to release device from the platform, please contact the administrator.',
            '500028': 'Only one device of the same type can be added in the test environment.',
            '500029': 'Bluetooth connection failed.',
            '500030': 'Failed to obtain device token.',
            '500031': 'Device token is invalid or has expired, please retrieve the device token again.',
            '500032': 'KeyPod failed to obtain unlock command.',
            '500033': 'KeyPod failed to obtain lock command.',
            '500034': 'KeyPod failed to obtain status query command.',
            '500035': 'KeyPod failed to obtain shutdown command.',
            '500036': 'The current platform is not bound to this device.',
            '500037': 'Platform ClientId is invalid.',
            '500038': 'Platform key information is missing, please complete the platform information on the website.',
            '500039': 'Platform has been canceled or banned.',
            '500040': 'Failed to update platform ApiToken.',
			'500041': 'Wrong username or password',
            '401': 'Platform ApiToken has expired.'
        },
        zh: {
            '600000': '参数校验默认异常类型。',
            '600001': '手机号不能为空。',
            '600002': '请求验证码的类型不能为空。',
            '600003': '图形验证码不能为空。',
            '600004': '图形验证码UUID不能为空。',
            '600005': '国家区号不能为空。',
            '600006': '国家区号长度有误，长度在1 ~ 999 之间。',
            '600007': '邮箱地址不能为空。',
            '600008': '邮箱格式非法。',
            '600009': '注册类型不能为空。',
            '600010': '昵称不能为空。',
            '600011': '头像不能为空。',
            '600012': '密码不能为空。',
            '600013': '密码长度有误，范围在8~30位之间。',
            '600014': '密码格式不正确，需要包含大小写字母和数字的8-16位密码。',
            '600015': '验证码不能为空。',
            '600016': '登录类型不能为空。',
            '600017': '设备蓝牙地址不能为空。',
            '600018': '设备所属环境不能为空。',
            '600019': '设备编码不能为空。',
            '600021': '设备类型不能为空。',
            '600022': '平台ClientId不能为空。',
            '600023': '授权方式不能为空。',
            '500000': '操作失败，请联系管理员（默认未知异常）。',
            '500001': '手机号不能为空。',
            '500002': '图形验证码错误。',
            '500003': '手机号不存在。',
            '500004': '手机号已存在。',
            '500005': '请求验证码时间间隔60秒。',
            '500006': '超过每天最大发送验证码次数，最大次数为10次。',
            '500007': '验证码发送失败。',
            '500008': '邮箱验证码下发失败。',
            '500009': '邮箱不存在。',
            '500010': '邮箱已存在。',
            '500011': '入参Body为空。',
            '500012': '验证码有误。',
            '500013': '邮箱地址不能为空。',
            '500014': '用户不存在。',
            '500015': '密码不能为空。',
            '500016': '平台登录失败，请联系管理员。',
            '500017': '用户名或密码错误。',
            '500018': '平台密钥为空，请联系管理员。',
            '500019': '请求头缺少环境类型参数。',
            '500020': '环境类型参数非法。',
            '500021': '数据解密失败。',
            '500022': '设备不存在。',
            '500023': '当前平台已存在该设备。',
            '500024': '当前平台添加设备出错，请联系管理员。',
            '500025': '设备已在其他平台绑定。',
            '500026': '设备不属于平台。',
            '500027': '平台释放设备失败，请联系管理员。',
            '500028': '测试环境下只能添加一个同类型的设备。',
            '500029': '蓝牙连接失败。',
            '500030': '获取设备token失败。',
            '500031': '设备token无效，或已过期，请重新获取设备token。',
            '500032': 'KeyPod获取开锁命令失败。',
            '500033': 'KeyPod获取关锁命令失败。',
            '500034': 'KeyPod获取状态查询命令失败。',
            '500035': 'KeyPod获取关机命令失败。',
            '500036': '当前平台未绑定该设备。',
            '500037': '平台ClientId无效。',
            '500038': '平台关键信息缺失，请前往网页补全平台信息。',
            '500039': '平台已注销或，已被封禁。',
            '500040': '更新平台ApiToken失败。',
			'500041': '用户名或密码错误',
            '401': '平台ApiToken已过期。'
        }
        // 可以继续添加其他语言和错误代码
    };

    // 根据传入的 language 和 code 返回对应的消息
    return messages[language] ? messages[language][code] : 'Unknown error code or language.';
};
